// extracted by mini-css-extract-plugin
module.exports = {"control":"_1tYgJH-LNX5nvlzzyekQPZ","red":"_2fR8gJ3Y_xR-1PIZ3Izikt","off":"Ieq6DtLgAYHP-upSRQAhh"};